import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhCollapseComponent } from './ph-collapse.component';

@NgModule({
  declarations: [PhCollapseComponent],
  exports: [PhCollapseComponent],
  imports: [CommonModule],
})
export class PhCollapseModule {}
